import SpaceService from "@/services/space";

const state = {
    space: null
};

const mutations = {
    changeSpace: (state, space) => { state.space = space }
}

const actions = {
    setSpace: ({ commit }, space) => {
        commit('changeSpace', space);
    },

    getSpace: ({ commit }, id) => {
        return new Promise(async (resolve, reject) => {
            const { data: space } = await SpaceService.getSpaceById(id);

            commit('changeSpace', space);

            resolve(space);
        });
    }
}

const getters = {
    space: state => state.space,
    status: state => (state.space) ? state.space.status : null
}

export const space = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/space.js